import React from 'react';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import { FQAdminProvider } from 'Views/Page/Content/Templates/FQAdminPanel/FQAdminContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { MainContent } from './MainContent';

const useStyles = buildUseStyles('FQAdminPanel', () => ({
  root: {
    height: '100%',
    display: 'flex',
  },
}));

const FQAdminPanel = () => {
  const classes = useStyles();
  const { pageContentResource } = usePageContentContext();

  useBoneBackgroundColor();

  return (
    <FQAdminProvider pageContentResource={pageContentResource}>
      <VerticalStack height={'screen'}>
        <Box className={classes.root}>
          <MainContent />
        </Box>
      </VerticalStack>
    </FQAdminProvider>
  );
};

export default FQAdminPanel;
